import pageLanguage from './pageLanguage'

const lng = pageLanguage()

const getAppIndex = () => {
  let index = 'Prod_WCM_SEARCH_EN_Featured'
  if (lng === 'ar') {
    index = 'Prod_WCM_SEARCH_AR_Featured'
  }
  return index
}

const getSortIndex = () => {
  let index = {
    popular: 'Prod_WCM_SEARCH_EN_Featured',
    asc: 'Prod_WCM_SEARCH_EN_Price_asc',
    desc: 'Prod_WCM_SEARCH_EN_Price_desc',
    newer: 'Prod_WCM_SEARCH_EN_Newer',
  }

  if (lng === 'ar') {
    index = {
      popular: 'Prod_WCM_SEARCH_AR_Featured',
      asc: 'Prod_WCM_SEARCH_AR_Price_asc',
      desc: 'Prod_WCM_SEARCH_AR_Price_desc',
      newer: 'Prod_WCM_SEARCH_AR_Newer',
    }
  }
  return index
}

export { getAppIndex, getSortIndex }
